import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../../core/app/consts";

export class BoxScoresWidgetLineupsToggleClickAnalyticsEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;
  gameId: Number;
  status: Number;
  clickType: Boolean;
  sportTypeId: Number;
  teamId: Number;

  constructor(params) {
    super('', 'toggle_click', 'lineups');

    this.source = params.source;
    this.gameId = params.gameId;
    this.status = params.status;
    this.clickType = params.clickType;
    this.sportTypeId = params.sportTypeId;
    this.teamId = params.teamId;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;
    properties.gameId = this.gameId;
    properties.status = this.status;
    properties.clickType = this.clickType;
    properties.sportTypeId = this.sportTypeId;
    properties.teamId = this.teamId;

    return properties;
  }
}